import { Directive, input, TemplateRef, ViewContainerRef, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractPurchasingService } from '../services/abstract-purchasing.service';
import { UiCapability } from '../enums';

@Directive({
  selector: '[hasCapability]'
})
export class HasCapabilityDirective {
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private purchasingService = inject(AbstractPurchasingService);

  private hasView = false;

  readonly hasCapability = input.required<UiCapability | UiCapability[]>();

  private capabilities = toSignal(this.purchasingService.capabilities$, { initialValue: [] as UiCapability[] });

  constructor() {
    effect(() => {
      this.updateView(this.hasCapability(), this.capabilities());
    });
  }

  private updateView(requiredCapabilities: UiCapability | UiCapability[], capabilities: UiCapability[]): void {
    const required = Array.isArray(requiredCapabilities) ? requiredCapabilities : [requiredCapabilities];
    const hasPermission = required.some(capability => capabilities.includes(capability));
    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
